import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Radio,
  RadioGroup,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react';
import { DragEndEvent } from '@dnd-kit/core';
import { FC } from 'react';
import { Crawler } from 'types/crawler';
import { MenuCrawler } from 'types/menuCrawler';
import { MenuRegistrationFormFields } from '../../../types/menuRegistrationFormFields';
import { CrawlerList } from '../../CrawlerList';

type Props = {
  values: MenuRegistrationFormFields;
  crawlers: Crawler[];
  menuCrawlers: MenuCrawler[];
  handleBack: () => void;
  handleSubmit: () => void;
  handleAddCrawler: (id: number, parentId: number) => void;
  handleDeleteCrawler: (id: number, parentId: number) => void;
  handleSortCrawler: (event: DragEndEvent) => void;
};

export const MenuRegistrationConfirmModalView: FC<Props> = ({
  values,
  crawlers,
  menuCrawlers,
  handleBack,
  handleSubmit,
  handleAddCrawler,
  handleDeleteCrawler,
  handleSortCrawler,
}) => (
  <form onSubmit={handleSubmit}>
    <ModalContent maxHeight="90vh">
      <ModalHeader p="40px">メニューの登録</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>メニューID</FormLabel>
            <Input
              type="text"
              value={values.id}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>メニュー名</FormLabel>
            <Input
              type="text"
              value={values.name}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>公開範囲</FormLabel>
            <RadioGroup name="type" defaultValue="general">
              <Radio value="general" isReadOnly>
                全顧客
              </Radio>
            </RadioGroup>
          </FormControl>
          <FormControl>
            <FormLabel>クローラー</FormLabel>
            <Box
              p="16px"
              borderRadius="md"
              border="solid 1px"
              borderColor="gray.200"
            >
              <CrawlerList
                menuCrawlers={menuCrawlers}
                crawlers={crawlers}
                parentId={-1}
                depth={0}
                update
                handleClickAdd={handleAddCrawler}
                handleDelete={handleDeleteCrawler}
                handleDragEnd={handleSortCrawler}
              />
            </Box>
          </FormControl>
          <FormControl>
            <FormLabel>説明</FormLabel>
            <Textarea
              value={values.description}
              rows={4}
              variant="flushed"
              isReadOnly
            />
          </FormControl>
        </Stack>
        <Text align="center" fontWeight="bold" mt="60px">
          上記の内容でメニューを登録しますか？
        </Text>
      </ModalBody>
      <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
        <Button
          w="140px"
          variant="outline"
          colorScheme="blackAlpha"
          onClick={handleBack}
        >
          入力画面に戻る
        </Button>
        <Button w="140px" colorScheme="blackAlpha" type="submit">
          登録
        </Button>
      </ModalFooter>
    </ModalContent>
  </form>
);
